<template>
  <div id="nav-container">
    <div id="logo-container">
      <img
        src="@/assets/logo.png"
        id="main-logo-image"
        @click="goToRoute('/')"
      />
      <span id="buy-rent-sell">
        <p class="title-descipion-text">buy.</p>
        <p class="title-descipion-text">rent.</p>
        <p class="title-descipion-text">sell.</p>
      </span>
    </div>
    <div id="account-action-container">
      <p
        :class="{ currentNavItem: currentRoute == 'Home' }"
        class="nav-item"
        @click="goToRoute('/')"
      >
        app
      </p>
      <p
        :class="{ currentNavItem: currentRoute == 'Blog' }"
        class="nav-item"
        @click="goToRoute('/blog')"
      >
        blog
      </p>
      <p
        :class="{ currentNavItem: currentRoute == 'Team' }"
        class="nav-item"
        @click="goToRoute('/team')"
      >
        team
      </p>
      <p
        :class="{ currentNavItem: currentRoute == 'support' }"
        class="nav-item"
        @click="goToRoute('/support')"
      >
        support
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  computed: {
    loggedIn() {
      return this.$store.getters['user/loggedIn'];
    },
    currentRoute() {
      return this.$route.name;
    }
  },
  methods: {
    goToRoute(path) {
      if (this.$route.path !== path) this.$router.push(path);
    }
  },
  created() {}
};
</script>

<style scoped>
.title-descipion-text {
  color: rgb(12, 192, 150);
  font-weight: bold;
  font-size: 20px;
  padding-left: 10px;
}
.currentNavItem {
  color: rgb(0, 160, 125);
  border-bottom: 1px solid rgb(12, 192, 150);
}
#logo-container {
  margin: 15px 0 0 15px;
}
#buy-rent-sell {
  height: 50px;
  display: flex;
  margin-left: -11px;
}
#nav-container {
  width: 100%;
  height: 88px;
  display: flex;
  background-color: #ffffff;
}
#account-action-container {
  height: min-content;
  float: right;
  display: flex;
  margin-left: auto;
  color: rgb(12, 192, 150);
  font-size: 25px;
}
#main-logo-image {
  width: 245px;
  cursor: pointer;
}
.nav-item {
  margin-right: 20px;
}
.nav-item:hover {
  cursor: pointer;
  color: rgb(0, 160, 125);
}
</style>
